import { handleErrorException, loading, error, success } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getUsageData = fetchData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.USAGE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Usage/GetUsages',
        fetchData
      );

      dispatch(success(types.USAGE_LIST, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while deleting usage list. Please try again.',
      };
      dispatch(handleErrorException(ex, types.USAGE_ERROR, defaultError));
    } finally {
      dispatch(loading(types.USAGE_LOADING, false));
    }
  };
};

export const deleteUsage = orderList => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.USAGE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Usage/DeleteUsage',
        orderList
      );
      dispatch(
        success(
          types.DELETE_SUCCESS_MESSAGE,
          response.data.Data ? response.data.Data : null
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while deleting usage list. Please try again.',
      };
      dispatch(handleErrorException(ex, types.USAGE_ERROR, defaultError));
    } finally {
      dispatch(loading(types.USAGE_LOADING, false));
    }
  };
};

export const getPrintUsageData = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_PREVIEW_USAGE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Usage/GetPrintUsage',
        printRequestData
      );
      const data = response.data.Data['ReportResultString'];
      if (data) {
        dispatch({
          type: types.SET_PRINT_DATA,
          payload: data,
        });
      }
      if (response.data.Data.Message) {
        dispatch(error(types.PRINT_PREVIEW_ERROR, response));
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while creating PDF. Please try again.',
      };
      dispatch(
        handleErrorException(ex, types.PRINT_PREVIEW_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PRINT_PREVIEW_USAGE_LOADING, false));
    }
  };
};

export const clearUsageGridData = () => {
  return {
    type: types.USAGE_CLEAR_GRID_DATA,
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};
export const clearUsageError = () => {
  return {
    type: types.CLEAR_USAGE_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/UsageList/actions.js